<template>
<div @click="$emit('click')" class="c-radio">
    <i class="icon-radio" :class="{selected:status}"></i>
    <span>{{label}}</span>
</div>
</template>
<script>
export default {
    name: 'cRadio',
    props: {
        //请求对象
        status: {
            type: Boolean
        },
        //分页对象
        label: {
            type: String
        }
    }
};
</script>
<style lang="scss" scoped>
@import 'src/style/frequently.scss';
.c-radio {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-right: 0.6rem;
    font-size: 0.14rem;
    .icon-radio {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 0.18rem;
        height: 0.18rem;
        border-radius: 50%;
        border: 1px solid #dfe2e5;
        margin-right: 0.1rem;
        box-sizing: border-box;
        position: relative;
        transition: 0.3s all;
        &.selected {
            background: $impColor;
            border: 1px solid $impColor;
            &::before {
                content: ' ';
                width: 0.06rem;
                height: 0.06rem;
                border-radius: 50%;
                background: white;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/commons/cRadio.vue